(ns cljs.core.match
  (:require-macros cljs.core.match))

(def backtrack (js/Error.))
